import React from 'react'
import { NumberInput } from '@contrast-security-inc/design-system-inputs'
import { useIntl } from 'react-intl'

export function DiagnosticCollectionDurationInput({
  value,
  onChange,
  isReadOnly
}: {
  value: string | number | undefined
  onChange: (value: string | number | undefined) => void
  isReadOnly?: boolean
}) {
  const { formatMessage } = useIntl()
  if (value !== undefined) {
    value = value.toString()
  }
  return (
    <NumberInput
      id="update-diagnostic-collection"
      label={formatMessage({
        id: 'title_diagnosticCollectionDuration'
      })}
      max="25"
      min="0"
      onChange={(_evt, value: string | undefined) => {
        onChange(value)
      }}
      isDisabled={isReadOnly}
      placeholder="0"
      step="1"
      value={value}
      isRequired
    />
  )
}
